import React from "react";
import PropTypes from "prop-types";

const RemoveItem = (props = {}) => {
  return (
    <div className="p-al-left p-mrg-ver">
      <span className="p-mrg-right">{props.label}</span>
      <span
        className="icon-close p-cursor-pointer p-clr-red"
        onClick={() => {
          props.onClick();
        }}
      />
    </div>
  );
};

RemoveItem.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default RemoveItem;



// WEBPACK FOOTER //
// src/components/manage/RemoveItem.js